import type { JSX } from 'react';
import classNames from 'classnames';
import { Card } from '@mantine/core';
import type { ICardFooterProps } from './types';
import classes from './Card.module.css';

function CardFooter({ children, className }: Readonly<ICardFooterProps>): JSX.Element {
  return <Card.Section className={classNames(classes.footer, className)}>{children}</Card.Section>;
}

export default CardFooter;
